<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wdKyKG/media/FC-9789948760757.jpg?1720819934089" alt="This image is the cover for the book بين الغيوم"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">بين الغيوم
      </h1>
      <p class="bookDescription body article font2">
        <p>ثريا محمد.. أخاطب الخيال دائمًا.. أقلِّب الصفحات بِخفَّة.. أسير مع تِلك الأحلام البعيدة.. قطارٌ مِن الخيالات مرَّاتٍ بِصحبة فلانِدر وهُوبر.. فيرا تِلك النقية تحيا لتُسعِد ذاك الغائب.. أحاديثُ تلمس دفء قلبك كُتِبَت بِكلِّ حُبٍّ وامتِنان.. أصدِقاءُ وأرضٌ رحبة، وُدٌّ بِكلِّ الأرجاء.. لِنُحِبَّ.. لِنَحيا بِسلام.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        ثريا
      </h2>
      
      <p class="authorDescription body article">ثريَّا فتاة في نهاية العشرينيَّات مِن عمُر الزهور.. تمشي بخِفَّة، تتأمَّل كلَّ شيء حولها بعينِ مُحبٍّ.. تعيش في هدوء.. تقضي أغلب الوقت بالقراءة والكتابة بتلك الصفحات.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52ddf090